import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "../../app/store";
import {MenuItemType} from "@commons/mapping/MenuItem";

const initialState: MenuItemType[] = [];

type PayloadMenuType = { siblingItems: MenuItemType[], current: MenuItemType };

/**
 * Chiude tutti i subMenu contenuti in <menuItems> and eccezione del menu indicato in <exceptMenu> e del menu corrispondente allo stato indicato in <exceptStato>
 * @param menuItems il menu completo
 * @param exceptMenu menu da nn chiudere
 * @param exceptStato stato da nn chiudere
 */
const closeSubMenu = function (menuItems: MenuItemType[],
                               exceptMenu: MenuItemType[] | null = null,
                               exceptStato: string | null = null): void {
    for (let menu of menuItems) {
        if (menu.menu) {
            if (menu.menuIsOpen && menu.menu !== exceptMenu && menu.path !== exceptStato) {
                menu.menuIsOpen = false;
            }

            closeSubMenu(menu.menu, exceptMenu, exceptStato);
        }
    }
}

/**
 * Restituisce il menu che contiene la voce indicata in <p.current> a partire da <p.siblingItems>
 * @param p
 */
const getSubMenu = function (p: PayloadMenuType): MenuItemType[] | null {
    for (let menu of p.siblingItems) {
        if (menu.menu) {
            let smenu = getSubMenu({siblingItems: menu.menu, current: p.current});
            if (smenu)
                return smenu;
        }
        if (menu.path === p.current.path)
            return p.siblingItems;
    }
    return null;
}

export const slice = createSlice({
        name: 'menuSlice',
        initialState,
        // The `reducers` field lets us define reducers and generate associated actions
        reducers: {
            setupMenu: (state, action: PayloadAction<MenuItemType[]>) => {
                // https://redux-toolkit.js.org/usage/immer-reducers
                // Instead, to replace the existing state, you should return the new value directly:
                return action.payload;
                // CORRECT: returns a new value to replace the old one
                // return initialState;
            },
            alignMenu: (state, action: PayloadAction<{ newStato: string, oldStato?: string }>) => {
                // https://redux-toolkit.js.org/usage/immer-reducers
                // Instead, to replace the existing state, you should return the new value directly:
                const browseMenu = (menu: MenuItemType[], paths: string[], current: boolean) => {
                    const path = paths[0];
                    for (let item of menu) {
                        if (item.path.localeCompare(path) === 0) {
                            if (item.menu) {
                                item.menuIsOpen = current;
                                browseMenu(item.menu, paths.slice(1), current);
                            } else {
                                item.current = current;
                            }
                            break;
                        }
                    }
                }

                let paths: string[];
                let numMenu: number;
                const {newStato, oldStato} = action.payload;
                if (oldStato) {
                    paths = oldStato.split('/');
                    numMenu = paths.length;
                    if (numMenu > 1) {
                        browseMenu(state, paths.slice(1), false);
                    }
                }
                paths = newStato.split('/');
                numMenu = paths.length;
                if (numMenu > 1) {
                    browseMenu(state, paths.slice(1), true);
                }
            },
            toggleMenu: (state, action: PayloadAction<PayloadMenuType>) => {
                const subMenu = getSubMenu({siblingItems: state, current: action.payload.current});
                if (subMenu) {
                    closeSubMenu(state, subMenu, action.payload.current.path);
                    for (let menu of subMenu) {
                        if (menu.path === action.payload.current.path) {
                            menu.menuIsOpen = !menu.menuIsOpen;
                        } else {
                            menu.menuIsOpen = false;
                        }
                    }
                }
            },
            activeMenuItem: (state, action: PayloadAction<string>) => {
                const setCurrent = function (menuItems: MenuItemType[], stato: string) {
                    for (let menu of menuItems) {
                        if (menu.menu) {
                            setCurrent(menu.menu, stato);
                        } else if (menu.path === stato) {
                            menu.current = true;
                        } else {
                            menu.current = false;
                        }
                    }
                }
                setCurrent(state, action.payload);
            },
        },
    })
;

export const {
    setupMenu,
    alignMenu,
    toggleMenu,
    activeMenuItem
} = slice.actions;
export default slice.reducer;

// Selector:
export const selectMenu = (state: RootState) => state.menu;
